import { Currency } from '../locale';

/**
 * Stripe only supports bank transfers (pay by invoice) for these currencies.
 * AUD and CAD customers will be limited to card payments only.
 */
export const BANK_TRANSFER_SUPPORTED_CURRENCIES: Currency[] = ['GBP', 'EUR', 'USD'];

export const MAX_MANUAL_INVOICE_DAYS_UNTIL_DUE = 60;

/**
 * See https://central.xero.com/s/article/About-multicurrency
 * The connected Xero tenant must have multi-currency enabled for non-GBP invoices.
 */
export const XERO_SUPPORTED_CURRENCIES: Currency[] = ['GBP', 'EUR', 'USD'];
